<script>
  let { children } = $props();
</script>

<style lang="scss">
  div {
    padding: calc(var(--spacing) * 2);
    background-color: var(--color-background-gray);
    padding-bottom: calc(var(--spacing) * 2);
    border-radius: 0 0 8px 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: -10px;
    position: relative;
  }
</style>

<div>
  {@render children?.()}
</div>
